import React, { Component } from 'react'
import { css } from '@emotion/core';
import BeatLoader from 'react-spinners/BeatLoader'

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

export default class Loader extends Component {

    render() {
        const {
            loading,
            text,
            classNameOfLoader
        } = this.props;

        return (
            <div className='loaderWrapper'>
                <BeatLoader css={override} loading={loading} className={classNameOfLoader === undefined || classNameOfLoader === null ? 'loaderDefaultStyle' : `loaderDefaultStyle ${classNameOfLoader}`} />
                {text === undefined || text === null ? '' : <p className='loaderText'>{text} </p>}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/main/resources/js/components/Loader.js